import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseTooltip } from 'shared/abstract/base-tooltip';
import { ListingValidationService } from '../../services/listing-validation.service';

@Component({
    selector: 'app-validation-errors',
    templateUrl: './validation-errors.component.html',
    styleUrls: ['./validation-errors.component.scss'],
    standalone: true,
    imports: [TranslateModule],
})
export class ValidationErrorsComponent extends BaseTooltip {
    data: any;

    protected listingValidationService = inject(ListingValidationService);
}
